import { type MenuId } from '../../../models';

export type PersonalizationSection =
  | 'request-access'
  | 'view-and-monitor'
  | 'manage-and-update'
  | 'passwords-and-security';

const personalizationSections: Record<PersonalizationSection, MenuId[]> = {
  'request-access': [
    'custom:start-access-request',
    'request-emergency-access-IDs',
    'request-emergency-access-roles',
  ],
  'view-and-monitor': [
    'view-existing-access',
    'pending-tasks',
    'request-history',
    'view-saved-requests',
  ],
  'manage-and-update': [
    'manage-my-access',
    'manage-delegate',
    'manage-service-accounts',
    'one-click-disable',
    'pending-approvals',
    'create-new-endpoint',
    'update-existing-endpoint',
    'create-new-entitlement',
    'update-existing-entitlement',
    'create-user-request',
    'update-user-request',
    'upload-user-request',
    'create-new-organization',
    'update-existing-organization',
    'upload-organization',
  ],
  'passwords-and-security': [
    'change-account-password-for-self',
    'reset-account-password-for-others',
    'reset-service-account-password',
    'reset-user-password',
  ],
};

export default personalizationSections;
